import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { ProductsQueryPayload } from "../../types/taxonomy";
import { PRODUCT_ID_QUERY } from "../../apis/taxonomy/queries";
import { TAXONOMY_CLIENT } from "../../utils/consts";

const productDataToNameMap = (
  products: ProductsQueryPayload["product"]["data"] | undefined
): Record<string, string> => {
  if (!products) return {};

  return products.reduce(
    (acc, product) => {
      if (product && product.id && product.name) {
        acc[String(product.id)] = product.name;
      }
      return acc;
    },
    {} as Record<string, string>
  );
};

export const useSimpleProductsLabel = (productIds: number[]): string => {
  const { data: productQueryData, loading: productsLoading } =
    useQuery<ProductsQueryPayload>(PRODUCT_ID_QUERY, {
      variables: {
        ids: productIds,
      },
      skip: productIds.length === 0,
      context: {
        clientName: TAXONOMY_CLIENT,
      },
    });

  const nameMap = useMemo(
    () => productDataToNameMap(productQueryData?.product.data),
    [productQueryData]
  );

  if (productIds.length > 0 && productsLoading) {
    return "Loading...";
  }

  if (productIds.length === 0) {
    return "All";
  }

  if (productIds.length === 1) {
    return nameMap[productIds[0]] || "1 selected";
  }

  return `${productIds.length} selected`;
};
